import LogoutIcon from "@mui/icons-material/Logout";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";

import { UserAccountResponse } from "components/entities";
import { AvatarInitial } from "components/common/AvatarInitial";
import { SidebarItems, SidebarItem } from "./SidebarItems";
import React from "react";
import { TooltipButton } from "components/common/TooltipButton";

interface UserProfileItemProps {
  isOpen: boolean;
  email: string;
  accountDetails: UserAccountResponse | undefined;
  profilePhoto: string;
  onLogout: () => Promise<void> | void;
  onOpenSettings: () => void;
  sidebarWidth: string;
}

export const UserProfileItem: React.FC<UserProfileItemProps> = ({
  isOpen,
  email,
  accountDetails,
  profilePhoto,
  onLogout,
  onOpenSettings,
  sidebarWidth,
}) => {
  const isLoaded = !!accountDetails;
  const displayName = accountDetails?.account_details?.name || email;

  const profileItem: SidebarItem = {
    id: "user-profile-button",
    icon: (
      <div className={isLoaded ? "" : "invisible"}>
        <AvatarInitial
          name={displayName}
          icon={profilePhoto}
          color={accountDetails?.account_details?.color as string}
          clientId={accountDetails?.account_details?.id}
          size="xs"
        />
      </div>
    ),
    text: isLoaded ? displayName : "\u00A0",
    secondaryText: isLoaded && displayName !== email ? email : undefined,
    // Settings lives in the flyout, not on the row: SidebarItems returns early
    // for any item with children, so a row-level onClick here never fires.
    children: [
      {
        icon: <SettingsOutlinedIcon className="icon-md" />,
        text: "Account settings",
        onClick: onOpenSettings,
      },
      {
        icon: <LogoutIcon className="icon-md" />,
        text: "Log Out",
        onClick: onLogout,
      },
    ],
    trailing: (
      <span className="transition-opacity invisible opacity-0 group-hover/rail-item:visible group-hover/rail-item:opacity-100">
        <TooltipButton
          title="Log Out"
          variant="contextual"
          size="xs"
          onClick={onLogout}
        >
          <LogoutIcon />
        </TooltipButton>
      </span>
    ),
  };

  return (
    <SidebarItems
      items={[profileItem]}
      isOpen={isOpen}
      variant="profile"
      sidebarWidth={sidebarWidth}
    />
  );
};
